import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, List, ListItem, Typography, makeStyles } from "@material-ui/core";
import { defaultGetItemLabel, identityRecordOfFieldEditorOptions } from "./utils";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
    list: { display: "flex", flexDirection: "column", rowGap: "6px" },
    listItem: {
        border: "1px solid #C1BEBB",
        borderRadius: "4px",
        backgroundColor: theme.palette.common.white,
        padding: "11px 14px",
        justifyContent: "space-between"
    },
    listItemLiteral: {
        justifyContent: "space-between"
    }
}), { name: "DployListField" });
export function ListField(props) {
    const { field, label, suffix, getItemLabel = defaultGetItemLabel, literal } = props;
    const classes = useStyles(props);
    const items = field.value;
    if (!items || items.length === 0) {
        return null;
    }
    return (_jsxs(Grid, { container: true, direction: "column", children: [!literal && label && label?.toString().trim().length > 0 ? (_jsx(Typography, { variant: "caption", children: label })) : null, _jsx(List, { className: classes.list, children: items.map(x => {
                    const label = getItemLabel(x);
                    const labelSplit = label.split(";");
                    return (_jsxs(ListItem, { className: clsx({
                            [classes.listItem]: !literal,
                            [classes.listItemLiteral]: literal
                        }), disableGutters: true, children: [_jsx(Typography, { variant: "body1", children: labelSplit[0] }), _jsxs(Typography, { variant: "body1", children: [labelSplit[1], suffix] })] }, label));
                }) })] }));
}
ListField.displayName = "DployListField";
const listFieldEditorProps = {
    editableOptions: {
        suffix: true
    }
};
export const EditorListFields = identityRecordOfFieldEditorOptions({
    ListField: listFieldEditorProps
});
//# sourceMappingURL=ListField.js.map